import SectionForm, { getFormField, useFormContext } from "../SectionForm"

const FieldList = [
  // Partie 1
  {name: "montant_taxe_fonciere", label: "Taxe foncière", type: "currency"},
  // Partie 2
  {name: "dispositif_fiscal", label: "Dispositif fiscal", type: "text"},
  // Partie 3
  {name: "procedure", label: "Procédure" },
]

// typeBien est passé en props car SectionForm
// ne crée les values dans le form que pour les fields définis
const FormContent = ({fields}) => {
  const { control, formErrors, errors } = useFormContext()
  return (
    <>
      <div className="flex flex-col items-center gap-4">                
        {getFormField(control, FieldList[0], 0) }
      </div>
      <div className="flex flex-col items-center gap-4">                
        {getFormField(control, FieldList[1], 1) }
      </div>
      <div className="flex flex-col items-center gap-4">                
        {getFormField(control, FieldList[2], 2) }
      </div>
    </>
  )
}

const Form = ({ title = "", onClose = () => {}, onSuccess = () => {} }) => {

  return (
    <SectionForm
      title={title}
      onClose={onClose}
      onSuccess={onSuccess}
      fields={FieldList.map( f => f.name)}
    >
      <FormContent fields={FieldList} />
    </SectionForm>
  )
}

export default Form